import { initializeApp } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate, RemoteConfig } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const remoteConfig: RemoteConfig = getRemoteConfig(app);

remoteConfig.settings.minimumFetchIntervalMillis = 3600;

remoteConfig.defaultConfig = {
  toggle_analytics: true,
};

export { remoteConfig };

export const fetchRemoteConfig = async (): Promise<boolean> => {
  try {
    await fetchAndActivate(remoteConfig);
    return true;
  } catch (error) {
    console.error('Erro ao buscar Remote Config:', error);
    return false;
  }
};
